export default __webpack_public_path__ + "static/skillmeter_logo_blue-06c40de27fe99f890474c81f1f41f404.png";